import React, { useState } from 'react';
import { Pane, PaneFooter, Button, Loading } from '@folio/stripes/components';
import { CancelEditModal, ListAppIcon } from '../../../../components';
import { t } from '../../../../services';
import css from './CreateListLayout.module.css';
export var CreateListLayout = function (_a) {
    var _b = _a.isSaveButtonDisabled, isSaveButtonDisabled = _b === void 0 ? false : _b, _c = _a.isSavingInProgress, isSavingInProgress = _c === void 0 ? false : _c, _d = _a.onCancel, onCancel = _d === void 0 ? function () { } : _d, _e = _a.onSave, onSave = _e === void 0 ? function () { } : _e, _f = _a.onClose, onClose = _f === void 0 ? function () { } : _f, _g = _a.showModalOnCancel, showModalOnCancel = _g === void 0 ? false : _g, children = _a.children;
    var _h = useState(false), showConfirmCancelEditModal = _h[0], setShowConfirmCancelEditModal = _h[1];
    var cancelHandler = function () {
        if (showModalOnCancel) {
            setShowConfirmCancelEditModal(true);
        }
        else {
            onCancel();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Pane, { dismissible: true, onClose: onClose, padContent: false, defaultWidth: "fill", appIcon: React.createElement(ListAppIcon, null), paneTitle: t('create-list.title'), paneSub: !isSavingInProgress ?
                t('create-list.subtitle') :
                React.createElement(React.Fragment, null,
                    t('create-list.saving'),
                    " ",
                    React.createElement(Loading, null)), footer: React.createElement("div", { className: css.createListFooterWrap },
                React.createElement(PaneFooter, { renderStart: React.createElement(Button, { onClick: cancelHandler }, t('button.cancel')), renderEnd: React.createElement(Button, { buttonStyle: "primary", disabled: isSaveButtonDisabled || isSavingInProgress, onClick: onSave }, t('button.save')) })) },
            React.createElement("div", { className: css.createListForm },
                React.createElement(Pane, { renderHeader: function () { return React.createElement("span", null); }, defaultWidth: "fill" }, children))),
        React.createElement(CancelEditModal, { onCancel: function () {
                setShowConfirmCancelEditModal(false);
                onClose();
            }, onKeepEdit: function () { return setShowConfirmCancelEditModal(false); }, open: showModalOnCancel && showConfirmCancelEditModal })));
};
